import React from "react";
import { Person } from "../Types/Configuration";
import PersonCard from "../SalesPerson/PersonCard";
import "./PersonsList.css";
import { IoMdPerson } from "react-icons/io";

interface PersonsListProps {
    people:Person[];
    isLoading: boolean;
}
const PersonsList: React.FC<PersonsListProps> = ({ people, isLoading }) => {
    const renderIcon = () => {
        const PersonIcon = IoMdPerson as any;
        return <PersonIcon/>;
    }
    return (
        <div className="persons-list-container">
         <div className="persons-list-tile">Yhteystiedot</div>
         <div className="persons-list-description">{renderIcon()}Myyjät</div>
        <div className="persons-list">
            {people.map((person, index) => (
                <PersonCard key={index} person={person} />
            ))}
        </div>
        </div>
    );
}
export default PersonsList;